import { AuditWrapper } from '../../../components/hub/AuditWrapper';
import { TechDebtPage } from '../../TechDebtPage';

export function HubTechDebtPage() {
  return (
    <AuditWrapper>
      <TechDebtPage />
    </AuditWrapper>
  );
}
